import { useState } from "react";
import { Calculator, IndianRupee } from "lucide-react";
import { useLang } from "@/i18n";

export function CalculatorCard() {
  const { t, lang } = useLang();
  const [amount, setAmount] = useState(100000);
  const [rate, setRate] = useState(18);
  const tax = Math.round((amount * rate) / 100);

  return (
    <div className="calculator-card" data-testid="gst-calculator">
      <div className="calc-head">
        <div className="icon-box"><Calculator size={20} /></div>
        <div>
          <span className="eyebrow">{t("calc.eyebrow")}</span>
          <h3>{t("calc.title")}</h3>
        </div>
      </div>
      <p>{t("calc.body")}</p>
      <label>
        {t("calc.taxable")}
        <div className="money-input">
          <IndianRupee size={16} />
          <input type="number" value={amount} onChange={(e) => setAmount(Number(e.target.value))} data-testid="calculator-amount-input" />
        </div>
      </label>
      <label>
        {t("calc.rate")}
        <select value={rate} onChange={(e) => setRate(Number(e.target.value))} data-testid="calculator-rate-select">
          <option value="5">5%</option>
          <option value="12">12%</option>
          <option value="18">18%</option>
          <option value="28">28%</option>
        </select>
      </label>
      <div className="calc-result">
        <span>{t("calc.result")}</span>
        <strong data-testid="calculator-result">₹{tax.toLocaleString(lang === "hi" ? "hi-IN" : "en-IN")}</strong>
      </div>
    </div>
  );
}
